import axios from 'axios';

const API_BASE_URL = import.meta.env.VITE_API_URL || 'https://awbbackend.bliitz.in';

const createAxios = () => {
    const instance = axios.create({ baseURL: API_BASE_URL });
    instance.interceptors.request.use((config) => {
        const token = localStorage.getItem('accessToken');
        if (token) {
            config.headers.Authorization = `Bearer ${token}`;
        }
        return config;
    });
    return instance;
};

const FileService = {
    uploadFile: async (file: File): Promise<{ filePath: string, url: string, originalName: string }> => {
        const formData = new FormData();
        formData.append('file', file);

        const api = createAxios();
        const response = await api.post('/api/upload', formData, {
            headers: {
                'Content-Type': 'multipart/form-data',
            },
        });

        return response.data;
    }
};

export default FileService;
